import GoExternal from '@clearkit/icons/glyphs/GoExternal';
import Salesforce from '@clearkit/icons/glyphs/Salesforce';
import map from 'lodash/map';

import { keyColors } from './colors';
import Group from './Group';

const color = keyColors.salesforce;

const SalesforceGroup = ({
  search,
  type,
  properties,
  externalId,
  externalInstanceUrl,
  extraSections,
  ...rest
}) => (
  <Group
    {...rest}
    title={`Salesforce ${type} – ${properties['Name']}`}
    sections={[
      [
        { label: 'ID', value: properties['Id'] },
        {
          label: `${type} Name`,
          value: properties['Name'],
        },
      ],
      extraSections,
      map(properties, (value, label) => ({ label, value })),
    ]}
    type="salesforce"
    search={search}
    icon={Salesforce}
    actionLink={
      <a
        href={`${externalInstanceUrl}/${externalId}`}
        rel="noopener noreferrer"
        className="inline-flex align-center"
        style={{ color }}
        onClick={(e) => e.stopPropagation()}
        target="_blank">
        View in Salesforce
        <GoExternal className="ml-2" />
      </a>
    }
  />
);

SalesforceGroup.propTypes = {
  search: PropTypes.string,
  type: PropTypes.string.isRequired,
  properties: PropTypes.object.isRequired,
  externalId: PropTypes.string.isRequired,
  externalInstanceUrl: PropTypes.string.isRequired,
  extraSections: PropTypes.array,
};

const SalesforceGroups = ({
  salesforceAccounts,
  salesforceContacts,
  salesforceLeads,
  search,
  salesforceAccountConnector,
}) => {
  return (
    <>
      {salesforceLeads.map(({ externalId, properties }, i) => (
        <SalesforceGroup
          search={search}
          key={i}
          type="Lead"
          properties={properties}
          externalId={externalId}
          externalInstanceUrl={salesforceAccountConnector.externalInstanceUrl}
        />
      ))}
      {salesforceContacts.map(({ externalId, properties }, i) => (
        <SalesforceGroup
          search={search}
          key={i}
          type="Contact"
          properties={properties}
          externalId={externalId}
          externalInstanceUrl={salesforceAccountConnector.externalInstanceUrl}
        />
      ))}

      {salesforceAccounts.map(
        ({ externalId, properties, opportunities }, i) => {
          return (
            <>
              <SalesforceGroup
                search={search}
                key={i}
                type="Account"
                properties={properties}
                externalId={externalId}
                externalInstanceUrl={
                  salesforceAccountConnector.externalInstanceUrl
                }
                extraSections={[
                  { label: 'Opportunities', value: opportunities },
                ]}
              />

              {opportunities.map(({ externalId, properties }, i) => (
                <SalesforceGroup
                  search={search}
                  key={i}
                  type="Opportunity"
                  properties={properties}
                  externalId={externalId}
                  externalInstanceUrl={
                    salesforceAccountConnector.externalInstanceUrl
                  }
                />
              ))}
            </>
          );
        },
      )}
    </>
  );
};

SalesforceGroups.propTypes = {
  salesforceAccounts: PropTypes.arrayOf(PropTypes.object),
  salesforceContacts: PropTypes.arrayOf(PropTypes.object),
  salesforceLeads: PropTypes.arrayOf(PropTypes.object),
  search: PropTypes.string,
  salesforceAccountConnector: PropTypes.shape({
    externalInstanceUrl: PropTypes.string,
  }),
};

export default SalesforceGroups;
